
export const Path = {
    login: "/login",
    home: "/home",
    end: "/end",
    test: "/test",
}
